import chroma from 'chroma-js';

export function getTextColorByBackground(hexColor) {
    
    if (!hexColor) return 'black'; // fallback
  
    const color = hexColor.replace('#', '');
    
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);
  
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  
    return brightness > 128 ? 'black' : 'white';

}



export function formartMillarNumber(value) {
    
    if (value === null || value === 0 || isNaN(value)) return "-";
    
    const numero = Number(value);
    const isInteiro = Number.isInteger(numero);
  
    return numero.toLocaleString("pt-BR", {

      minimumFractionDigits: isInteiro ? 0 : 1,
      maximumFractionDigits: 1
      
    })

  }


export function formatDate(date) {
  if (!date) return '';

  const [year, month, day] = String(date).split('-');

  return `${day}/${month}/${year.slice(-2)}`;
}


export function formatFloatOneDecimal(value) {
    
    if (value === null || value === undefined || isNaN(value)) return "-";
    
    const numero = Number(value);
    const isInteiro = Number.isInteger(numero);
  
    return numero.toLocaleString("en-US", {
      minimumFractionDigits: isInteiro ? 0 : 1,
      maximumFractionDigits: 1
    }).replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.');

  }


// "bolinha" antes do texto
export const dot = (color = "transparent") => ({
  alignItems: "center",
  display: "flex",
  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10,
  },
});

// Styles do Select com cor por option.data.colorHex
export const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),

  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.colorHex);

    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? data.colorHex
        : isFocused
        ? color.alpha(0.1).css()
        : undefined,

      color: isDisabled
        ? "#ccc"
        : isSelected
        ? chroma.contrast(color, "white") > 2
          ? "white"
          : "black"
        : data.colorHex,

      cursor: isDisabled ? "not-allowed" : "default",

      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled
          ? isSelected
            ? data.colorHex
            : color.alpha(0.3).css()
          : undefined,
      },
    };
  },

  input: (styles) => ({ ...styles, ...dot() }),
  placeholder: (styles) => ({ ...styles, ...dot("#ccc") }),
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.colorHex) }),
};

export const SelectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? "1px solid #00aaff" : "1px solid defaultColor",
    boxShadow: state.isFocused ? "0 0 0 1px rgba(0, 170, 255, 0.5)" : "none",
  }),

  input: (base) => ({
    ...base,
    color: "inherit",
  }),
};
  

export const formatNumberBR = (value) => {
    const num = Number(value);
    return num.toLocaleString('pt-BR', {
        minimumFractionDigits: Number.isInteger(num) ? 0 : 1,
        maximumFractionDigits: 1
    });
};